import React from "react";
import styles from "./MyCourse.module.css";

export default function MyCourse() {
  return (
    <>
      <section className={`${styles.myCourse} container`}>
        <div className={styles.content}>
          <div className={styles.description}>
            <h1>Learn Liquid & Updated Shopify Theme Templating In 2026</h1>            
           
            <p>
              A practical Arabic introduction to Shopify Liquid, theme
              structure, and template logic for building more flexible Shopify
              storefronts.
            </p> 
            <span className={styles.label}>
              <span className={styles.liveIcon}></span>
              Free Shopify Theme Templating Live Now On YouTube
            </span>
            <br></br>
            <a
              className={styles.viewButton}
              href="https://www.youtube.com/watch?v=-J_n8etzpAw"
              target="_blank"  rel="noopener noreferrer"
            >
              View Now
            </a>
          </div>

          <div className={styles.videosGrid}>
            <div className={styles.videoCard}>
              <span className={styles.videoLabel}>Part 1</span>
              <div className={styles.videoFrame}>
                <iframe
                  src="https://www.youtube.com/embed/-J_n8etzpAw"
                  title="تعلم برمجة لغة الليكويد و قوالب الشوبيفاي بالعربي | Introduction to Liquid & Theme Templating"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>

            <div className={styles.videoCard}>
              <span className={styles.videoLabel}>Part 2</span>
              <div className={styles.videoFrame}>
                <iframe
                  src="https://www.youtube.com/embed/fdvlmKgkzo8"
                  title="تعلم تطوير Shopify Themes بالعربي - الجزء الثاني | Advanced Shopify Theme Development"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
